module.exports = __webpack_public_path__ + "img/cart2.683d0a9c.png";